/**
 * Formata frete do Product para exibição no admin.
 *
 * - Legado / checkout V2 corrigido: `shipping` em reais → cashnatorFloat
 * - Bug antigo do checkout V2: centavos persistidos (ex.: 1245 → R$12,45)
 *   detectado quando há checkoutSessionId e o valor é inteiro absurdo para frete BR
 */

import { cashnator, cashnatorFloat } from "./functions";

/** Frete Correios típico raramente passa de R$200; acima disso com sessão = centavos. */
const CENTS_LIKELY_THRESHOLD = 200;

/**
 * @param {number|null|undefined} shipping
 * @param {{ checkoutSessionId?: string|null, shippingShared?: boolean }} [meta]
 * @returns {string|null}
 */
export const formatProductShipping = (shipping, meta = {}) => {
  if (shipping == null || shipping === "" || Number(shipping) === 0) {
    return null;
  }
  const value = Number(shipping);
  if (!Number.isFinite(value)) {
    return null;
  }

  const looksLikeCentsBug =
    Boolean(meta.checkoutSessionId)
    && Number.isInteger(value)
    && value >= CENTS_LIKELY_THRESHOLD;

  if (looksLikeCentsBug) {
    return cashnator(value);
  }
  return cashnatorFloat(value);
};

export const packagePanelLabel = (product = {}) => {
  const id = product.shippingPackageId ? String(product.shippingPackageId) : "—";
  const cards = Number(product.numberOfCards) || 0;
  const cardsLabel = `${cards} carta${cards === 1 ? "" : "s"}`;
  if (product.delivery === "presencial") {
    return `Pacote ${id} · retirada presencial · ${cardsLabel}`;
  }
  const service = product.shippingService ? String(product.shippingService).toUpperCase() : "Correios";
  return `Pacote ${id} · Correios ${service} · ${cardsLabel}`;
};

/**
 * Texto auxiliar quando o frete é do checkout multi-lote.
 * @returns {string|null}
 */
export const shippingSharedLabel = ({
  shippingShared,
  checkoutItemCount,
  shippingChargedOnThisProduct,
} = {}) => {
  if (!shippingShared) {
    return null;
  }
  const count = Number(checkoutItemCount);
  const siblings = Number.isFinite(count) && count > 1 ? count - 1 : null;
  const base = siblings != null && siblings > 0
    ? `Frete do checkout — compartilhado com ${siblings} outro${siblings === 1 ? "" : "s"} lote${siblings === 1 ? "" : "s"}`
    : "Frete do checkout — compartilhado com outros lotes do mesmo pagamento";
  if (shippingChargedOnThisProduct === false) {
    return `${base} (cobrado no lote principal do checkout)`;
  }
  if (shippingChargedOnThisProduct === true) {
    return `${base} (este lote incorpora o frete no preço final)`;
  }
  return base;
};
